import * as React from "react"
import {useEffect, useState} from "react"
import {useNavigate} from "react-router-dom"
import {apiRequestGetQuizzes} from "../../api/apiRequests"
import Loader from "../ui/Loader"

interface Quiz {
  id: number,
  title: string,
  imageFilename: string | null,
  position: number,
}

const QuizListPage = () => {
  const [quizzes, setQuizzes] = useState<Quiz[]>([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  useEffect(() => {
    apiRequestGetQuizzes().then((data) => {
      if (Array.isArray(data)) setQuizzes(data)
      setLoading(false)
    })
  }, [])

  if (loading) return <div className="quiz-list__loader"><Loader/></div>

  return (
    <section className="quiz-list">
      <div className="container">
      <div className="quiz-list__header">
        <h2 className="quiz-list__title">Complete quizzes and learn more about yourself!</h2>
      </div>
      <div className="quiz-list__grid">
        {quizzes.map((quiz) => (
          <div
            key={quiz.id}
            className="quiz-card"
            style={quiz.imageFilename ? {backgroundImage: `url(/images/quizzes/${quiz.imageFilename})`} : undefined}
          >
            <div className="quiz-card__overlay"/>
            <div className="quiz-card__content"/>
            <div className="quiz-card__footer">
              <button
                className="quiz-card__btn"
                onClick={() => navigate(`/quizzes/${quiz.id}`)}
              >
                Let's Start
              </button>
            </div>
          </div>
        ))}
      </div>
      </div>
    </section>
  )
}

export default QuizListPage
